import React, { useEffect, useState } from "react";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import { useEventStore } from "../../../stores/eventStore";
import { format, isAfter, isSameDay, startOfDay, addDays, isSameMonth } from "date-fns";

const UpcomingEventsWidget = () => {
  const { localEvents, fetchLocalEvents } = useEventStore();
  const [filter, setFilter] = useState("All");
  
  useEffect(() => {
    fetchLocalEvents();
  }, [fetchLocalEvents]);

  // Filter and sort events to find upcoming ones
  const today = startOfDay(new Date());
  
  const upcomingEvents = localEvents
    .filter(e => {
      const eDate = new Date(e.date);
      // All future and today events
      const isUpcoming = isAfter(eDate, today) || isSameDay(eDate, today);
      if (!isUpcoming) return false;

      if (filter === "Today") {
        return isSameDay(eDate, today);
      } else if (filter === "15 Days") {
        return eDate <= addDays(today, 15);
      } else if (filter === "This Month") {
        return isSameMonth(eDate, today);
      }
      return true; // "All"
    })
    .sort((a, b) => new Date(a.date) - new Date(b.date));

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5 flex flex-col gap-4 h-full">
      <div className="flex flex-col gap-3 border-b pb-3">
        <div className="flex justify-between items-center">
          <h3 className="font-bold text-gray-800 flex items-center gap-2">
            <EventAvailableIcon className="text-pink-500" />
            Upcoming Events
          </h3>
        </div>
        <div className="flex gap-2 bg-gray-50 p-1 rounded-lg w-full">
          {["Today", "15 Days", "This Month", "All"].map(opt => (
            <button
              key={opt}
              onClick={() => setFilter(opt)}
              className={`flex-1 text-[10px] font-bold py-1 rounded-md transition-colors ${filter === opt ? "bg-white text-pink-600 shadow-sm" : "text-gray-500 hover:bg-gray-100"}`}
            >
              {opt}
            </button>
          ))}
        </div>
      </div>
      <div className="h-64 flex flex-col gap-3 mt-2 overflow-y-auto scrollbar-thin pr-1">
        {upcomingEvents.length === 0 ? (
           <p className="text-sm text-gray-400 text-center mt-4">No upcoming events.</p>
        ) : (
          upcomingEvents.map((e, idx) => (
            <div key={idx} className="flex gap-3 items-center bg-gray-50/50 p-2 rounded-lg hover:bg-gray-50 transition-colors">
              <div className="bg-pink-50 text-pink-600 rounded-lg p-2 text-center w-12 flex-shrink-0">
                <p className="text-xs font-bold uppercase">{format(new Date(e.date), "MMM")}</p>
                <p className="text-lg font-black leading-none mt-0.5">{format(new Date(e.date), "dd")}</p>
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-gray-800 text-sm truncate" title={e.title}>{e.title}</p>
                <p className="text-[10px] font-medium text-gray-500 mt-0.5">{format(new Date(e.date), "h:mm a")} • {e.category}</p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default UpcomingEventsWidget;
